import React from 'react'
import { Dialog, useMediaQuery } from '@mui/material'
import { alpha, useTheme } from '@mui/material/styles'
import { useCart } from '../../providers/Cart'
import { CheckoutBody } from './CheckoutBody'
import { useExitConfirm } from './ExitConfirm'
import { detectStripeReturn, loadPersisted } from './persistence'

export const CheckoutDialog: React.FC = () => {
  const cart = useCart()
  const { requestExit, dialog: exitDialog } = useExitConfirm()
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

  // Stripe 3DS redirect lands back here: rehydrate cart + reopen; CheckoutBody does the rest.
  React.useEffect(() => {
    if (typeof window === 'undefined') return
    if (!detectStripeReturn()) return
    const persisted = loadPersisted()
    if (!persisted) return
    cart.restore(persisted.cartItems, { openCheckout: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClose = () => requestExit(() => cart.closeCheckout())

  return (
    <>
      <Dialog
        open={cart.isCheckoutOpen}
        onClose={handleClose}
        maxWidth={false}
        fullScreen={fullScreen}
        slotProps={{
          backdrop: {
            sx: { backgroundColor: (t) => alpha(t.palette.common.black, 0.65) },
          },
          paper: {
            sx: {
              m: { xs: 0, sm: 2 },
              maxWidth: { xs: '100%', sm: 700 },
              width: '100%',
              borderRadius: { xs: 0, sm: '6px' },
              boxShadow: '0 30px 80px rgba(0,0,0,0.35)',
              backgroundColor: 'common.white',
              overflow: 'hidden',
              animation: 'cm-fade-up 0.22s ease-out',
              '@keyframes cm-fade-up': {
                from: { opacity: 0, transform: 'translateY(12px)' },
                to: { opacity: 1, transform: 'translateY(0)' },
              },
            },
          },
        }}
      >
        {cart.isCheckoutOpen && <CheckoutBody requestExit={requestExit} />}
      </Dialog>
      {exitDialog}
    </>
  )
}
